import React, { useCallback, useEffect, useState } from 'react';
import { TableInput } from '../../../../components/common';
import { Table } from '../../../../components/ui/renderTable/styled';
import axios from 'axios';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import {
  AddButton,
  SaveButton,
} from '../../../../components/common/button/CustomButtons';

const AddRiPartTable = (props: any) => {
  const { setOpenModal, handleSaveTableData, initialData } = props;
  const [riparts, setRiParts] = useState([]);
  const [tableData, setTableData] = useState<any>([
    {
      ri_part_id: null,
      quantity: null,
      _tempId: `temp-id-${new Date().getTime()}`,
    },
  ]);
  useEffect(() => {
    if (initialData) setTableData(initialData);
    axios
      .get('/api/riDepartment/riPart/getAutocompletedata')
      .then((res) => {
        if (res?.data) {
          setRiParts(res?.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const addRows = useCallback(() => {
    setTableData((prev: any) => {
      return [
        ...prev,
        {
          ri_part_id: null,
          quantity: null,
          _tempId: `temp-id-${new Date().getTime()}`,
        },
      ];
    });
  }, []);

  const handleData = useCallback(
    (rowIndex: number | null, key: string, newValues: any) => {
      setTableData((prev: any) => {
        const upadateCompartment: any = [...prev];
        if (rowIndex === null) return;
        const updatedRow = upadateCompartment?.[rowIndex];
        updatedRow[key] = newValues;
        upadateCompartment[rowIndex] = updatedRow;
        return upadateCompartment;
      });
    },
    []
  );

  const handleInputChange = (
    fieldName: string,
    value: string | number | null,
    index: number
  ) => {
    handleData(index, fieldName, value);
  };

  const handleSave = () => {
    const allRowsFilled = tableData.every(
      (row: any) => row.ri_part_id !== null
    );
    const allQuantityFilled = tableData.every(
      (row: any) => row.quantity !== null
    );
    if (!allRowsFilled) {
      alert(
        '🚫 All RI PARTS must be completed. Please fill in all the required fields.'
      );
      return;
    }
    if (!allQuantityFilled) {
      alert(
        '🚫 All quantity fields must be completed. Please provide the necessary quantities.'
      );
      return;
    }
    handleSaveTableData(tableData);
    setOpenModal(false);
  };

  return (
    <Table style={{ width: '80vh' }}>
      <div
        style={{
          position: 'absolute',
          right: '135px',
          top: '0px',
        }}
      >
        <SaveButton
          label="Save"
          onClick={() => {
            handleSave();
          }}
          sx={{ background: '#1864ab' }}
        />
      </div>
      <div
        style={{
          position: 'absolute',
          right: '250px',
          top: '0px',
        }}
      >
        <AddButton
          onClick={() => {
            addRows();
          }}
          label="Add Part"
          sx={{ background: '#1864ab' }}
        />
      </div>
      <thead>
        <tr>
          <th>S.No.</th>
          <th>RI PARTS</th>
          <th>Qty</th>
        </tr>
      </thead>
      <tbody>
        {tableData?.map((part: any, index: number) => (
          <tr key={part?._id || part?._tempId}>
            <th>{index + 1}</th>
            <td style={{ minWidth: '150px', textAlign: 'center' }}>
              <AutocompleteMuiCustom
                id="part_number"
                label=""
                option_name="part_number"
                arrayofObj={riparts}
                value={part?.ri_part_id || ''}
                onChange={(e, value) => {
                  handleInputChange('ri_part_id', value, index);
                }}
              />
            </td>
            <td style={{ minWidth: '100px', textAlign: 'center' }}>
              <TableInput
                name="quantity"
                key="quantity"
                type="number"
                isView={false}
                value={part?.quantity}
                onChange={(e) => {
                  handleInputChange('quantity', e.target.value, index);
                }}
              />
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        {/* <tr>
          <th colSpan={2}>Total QUANTITY</th>
          <th>{}</th>
        </tr> */}
      </tfoot>
    </Table>
  );
};

export default AddRiPartTable;
